export function PlatformPageHeader({ title, lead }: { title: string; lead?: string }) {
  return (
    <header className="site-platform-header">
      <p className="site-utility-kicker">Platform console</p>
      <h1>{title}</h1>
      {lead ? <p className="site-platform-lead">{lead}</p> : null}
    </header>
  );
}
